import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';

import { ProductInspectionResponse, AllProductInspectionsResponse } from '@gtpl/shared-models/production-management';
import { ProductInspectionDTO } from '../dto/product-inspection.dto';
import { ProductInspectionService } from './product-inspection.service';
import { ProductInspecRequest } from '../dto/product-inspection.request';
@ApiTags('Product Inspection')
@Controller('product-inspection')
export class ProductInspectionController {
    constructor(
        private service: ProductInspectionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createProductInspection')
    async createProductInspectionInfo(@Body() inspecInfo: ProductInspectionDTO): Promise<ProductInspectionResponse>{
        try{ 
            return await this.service.createProductInspectionInfo(inspecInfo, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProductInspectionResponse, error);
        }
    }
    @Post('/updateProductInspection')
    async updateProductInspectionInfo(@Body() inspecInfo: ProductInspectionDTO): Promise<ProductInspectionResponse>{
        try{ 
            return await this.service.createProductInspectionInfo(inspecInfo, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProductInspectionResponse, error);
        }
    }

    @Post('/getAllProductInspections')
    async getAllProductInspectionsInfo(): Promise<AllProductInspectionsResponse>{
        try{ 
            return await this.service.getAllProductInspections();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllProductInspectionsResponse, error);
        }
    }

    @Post('/getAllActiveProductInspections')
    async getAllActiveProductInspectionsInfo(): Promise<AllProductInspectionsResponse>{
        try{ 
            return await this.service.getAllActiveProductInspections();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllProductInspectionsResponse, error);
        }
    }

    @Post('/activateOrDeactivateInspection')
    async activateOrDeactivateInspectionInfo(@Body() req: ProductInspecRequest): Promise<ProductInspectionResponse>{
        try{ 
            return await this.service.activateOrDeactivateInspection(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProductInspectionResponse, error);
        }
    }

    @Post('/createSamples')
    async createSamples(@Body() inspecInfo: ProductInspectionDTO):Promise<CommonResponse>{
        try{
            return await this.service.createSamples(inspecInfo);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getAllProductInspectionSamplesForSampleId')
    async getAllProductInspectionSamplesForSampleId(@Body() qReq: ProductInspecRequest): Promise<ProductInspectionResponse> {
        try {
            return await this.service.getAllProductInspectionSamplesForSampleId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ProductInspectionResponse, error);
        }
    }
}
